module.exports = __webpack_public_path__ + "static/img/logo10.529cedb9.png";